module.exports = __webpack_public_path__ + "static/media/twitch-mobile-1.f0424986.svg";